<!-- <div>
    <img *ngIf="data?.action === 'deleteitem'" src="" alt="">
    <img *ngIf="data?.action === 'additem'" src="" alt="">

    <button (click)="close(data?.action)">X</button>
    <h4>{{data?.msg?.message1}}</h4><br>
    <h6>{{data?.msg?.message2}} <a href="javascript:void(0)" *ngIf="data?.action === 'deleteitem'" (click)="deleteItem('add-again')">Click here to add</a></h6>
    
</div> -->

<div class="SUBCRP-tstr-box">
    <div class="SUBCRP-tstr-box-innr">
        <button class="SUBCRP-tstr-cls-btn" (click)="close(data?.action)"><img src="assets/img/detail-close-icon.svg" alt=""
                class="SUBCRP-tstr-cls-icn" /></button>
        <div class="SUBCRP-tstr-icon" [ngClass]="data?.action == 'additem'?'white-bg':''">
            <img *ngIf="data?.action === 'deleteitem' || data?.action === 'deleteWishItem'" src="assets/img/trash-new-icon.svg" class="SUBCRP-stus-icon" />
            <img *ngIf="data?.action === 'addtocart'" src="assets/img/cart-toaster-img.svg" class="SUBCRP-stus-icon" />
            <i class="fas fa-heart SUBCRP-stus-icon" *ngIf="data?.action === 'additem'"></i>
        </div>
        <div class="SUBCRP-tstr-cnt-area">
            <h3 class="SUBCRP-tstr-hdng">{{data?.msg?.message1}}</h3>
            <h3 class="SUBCRP-tstr-subhdng">{{data?.msg?.message2}} <button class="SUBCRP-tstr-txtbtn" *ngIf="data?.action === 'deleteitem' || data?.action === 'deleteWishItem'" (click)="close('add-again')">Click here to add</button></h3>
        </div>
    </div>
</div>